import React from "react";

const articles = [
  {
    id: 1,
    image: "/e1.png",
    tag: "",
    title: "Top 5 Tips for Managing Cash Flow",
    author: "Shailendar D",
    date: "Feb 05, 2026",
    shares: "1K shares",
    excerpt:
      "Effective cash flow management is the backbone of successful business operations. Learn the essentials...",
  },
  {
    id: 2,
    image: "/e2.png",
    tag: "",
    title: "Digital Transformation in NBFCs",
    author: "Sandeep Kumar",
    date: "Jan 25, 2026",
    shares: "1K shares",
    excerpt:
      "Discover how technology is revolutionizing the financial services sector and what it means for you...",
  },
  {
    id: 3,
    image: "/e3.png",
    tag: "",
    title: "The Future of Digital Lending",
    author: "Vikram Sharma",
    date: "Dec 28, 2025",
    shares: "1K shares",
    excerpt:
      "Key trends driving the next phase of growth in India's NBFC and lending ecosystem.",
  },
];

const Testimonials = () => {
  return (
    <section className="bg-[#F5F7FB] py-12 md:py-16 lg:py-20 px-4 md:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-3">
            Simple <span className="text-blue-600">Application Process</span>
          </h2>
          <p className="text-base md:text-lg text-slate-600">
            Get started with your financial journey in just three easy steps
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {articles.map((article) => (
            <article
              key={article.id}
              className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 flex flex-col"
            >
              {/* Image + optional Tag */}
              <div className="relative w-full h-60 md:h-64 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover"
                />
                {article.tag && (
                  <span className="absolute top-4 left-4 rounded-full bg-black/60 text-white text-xs md:text-sm font-medium px-3 py-1">
                    {article.tag}
                  </span>
                )}
              </div>

              {/* Content */}
              <div className="bg-[#18346A] text-white flex-1 px-6 py-6 md:px-7 md:py-7 flex flex-col">
                <h3 className="text-lg md:text-xl font-semibold leading-snug mb-3">
                  {article.title}
                </h3>

                {/* Meta */}
                <div className="flex items-center gap-3 text-xs md:text-sm text-slate-200/90 mb-3">
                  <span>{article.author}</span>
                  <span className="w-1 h-1 rounded-full bg-slate-300" />
                  <span>{article.date}</span>
                  <span className="w-1 h-1 rounded-full bg-slate-300" />
                  <span>{article.shares}</span>
                </div>

                <p className="text-sm md:text-base text-slate-100/90 leading-relaxed mb-4 flex-1">
                  {article.excerpt}
                </p>

                <button
                  type="button"
                  className="mt-auto inline-flex items-center gap-2 text-sm md:text-base font-semibold text-white hover:text-blue-200 transition-colors"
                >
                  
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
